module.exports = __webpack_public_path__ + "static/video-5424269efe73eb495e88703eae21af2c.mp4";